(() => {
  const config = document.getElementById('nfm-bucket-config');
  if (!config) return;
  const c = JSON.parse(config.textContent);
  for (const key of Object.keys(c)) {
    c[key] = c[key].replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
  }
  const isRequest = location.pathname.startsWith('/apps/request-a-quote') || location.pathname === '/pages/sc-raq-quote-list';
  const main = document.getElementById('MainContent');
  const catalog = '/pages/nfm-flower-collection-and-quotes?view=internal-quote';
  const replacements = new Map([
    ['Add to Quote', c.add], ['Add To Quote', c.add], ['View Quote', c.bucket],
    ['Flower Quote', c.request], ['Your quote is currently empty.', c.empty],
    ['Submit', c.send], ['Submit Quote', c.send], ['Request a Quote', c.send],
    ['Flower Ready Date', c.date], ['Order Notes', c.note],
    ['Continue Shop', c.browse], ['Continue Shopping', c.browse]
  ]);
  function rename(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement.closest('script,style,textarea,input,option,[contenteditable]')) continue;
      const old = node.textContent.trim();
      let next = replacements.get(old);
      if (!next && /^Add ".+" to quote$/.test(old)) next = old.replace(/^Add /, 'Added ').replace(/ to quote$/, ' to your bucket');
      if (next && old !== next) node.textContent = node.textContent.replace(old, next);
    }
  }
  function icon(link) {
    if (link.querySelector('.nfm-bucket-icon')) return;
    const img = document.createElement('img');
    img.src = c.icon; img.alt = ''; img.width = 42; img.height = 46;
    img.className = 'nfm-bucket-icon';
    link.prepend(img);
    link.classList.add('nfm-bucket-link');
  }
  function note(id, before, text) {
    if (!before || document.getElementById(id)) return;
    const p = document.createElement('p');
    p.id = id; p.className = 'nfm-bucket-review'; p.textContent = text;
    before.before(p);
  }
  function refresh() {
    observer.disconnect();
    document.querySelectorAll('.nfm-quote-portal, #storeify-chooseproduct-modal, #storeify-mes-modal, #storeify_form_quote, .storeify-empty-quote').forEach(rename);
    document.querySelectorAll('.nfm-view-quote, #storeify-mes-modal a[href*="/apps/request-a-quote"]').forEach(icon);
    if (isRequest && main) {
      rename(main);
      document.querySelectorAll('.ify-summary-title, .ify-summary-total > span:first-child').forEach(el => {
        if (el.textContent !== c.total) el.textContent = c.total;
      });
      const submit = main.querySelector('.storeify-submit-btn');
      if (submit) {
        if (submit.tagName === 'INPUT') submit.value = c.send;
        else if (submit.textContent.trim() !== c.send) submit.textContent = c.send;
        note('nfm-bucket-submit-note', submit, c.review);
      }
      main.querySelectorAll('.storeify-empty-quote a').forEach(a => { a.href = catalog; });
      main.querySelectorAll('.storeify-number-qty').forEach(input => {
        input.setAttribute('aria-label', 'Number of bunches');
        if (!input.dataset.nfmBucketQuantity) {
          input.dataset.nfmBucketQuantity = 'true';
          let timer;
          const update = () => {
            clearTimeout(timer);
            const quantity = Number(input.value);
            const minimum = Number(input.min) || 1;
            if (!Number.isSafeInteger(quantity) || quantity < minimum) return;
            const increment = input.parentElement.querySelector('.storeify-btn-add');
            if (!increment) return;
            input.value = String(quantity - 1);
            increment.click();
          };
          input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(update, 250); });
          input.addEventListener('change', update);
        }
      });
      main.querySelectorAll('label').forEach(label => {
        if (label.textContent.trim() === c.date && label.htmlFor) {
          document.getElementById(label.htmlFor)?.setAttribute('aria-label', c.date);
        }
      });
    }
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (main) {
    if (isRequest) {
      const heading = document.createElement('h1');
      heading.className = 'nfm-bucket-heading'; heading.textContent = c.bucket;
      icon(heading); main.prepend(heading);
      note('nfm-bucket-intro', heading.nextElementSibling, c.intro + ' ' + c.review);
    } else if (!main.querySelector('.nfm-quote-portal')) {
      const bar = document.createElement('div'); bar.className = 'nfm-bucket-product-bar';
      const link = document.createElement('a'); link.href = '/apps/request-a-quote/index';
      link.textContent = c.bucket; link.className = 'nfm-view-quote'; icon(link);
      bar.append(link); main.prepend(bar);
      note('nfm-bucket-product-note', bar.nextElementSibling, c.intro);
    }
  }
  if (document.querySelector('.nfm-quote-portal')) document.title = c.title + ' – Nashville Flower Market';
  if (isRequest) document.title = c.bucket + ' – Nashville Flower Market';
  const observer = new MutationObserver(refresh);
  refresh();
})();
